// Avatar & Profile Manager for WePlay Web
export class AvatarManager {
  constructor() {
    this.avatars = ['🦊', '🐼', '🐱', '🐶', '🤖', '👽', '🐲', '🥷', '🦄', '🐯', '🐰', '🦁'];
    this.profile = this.loadProfile();
  }

  loadProfile() {
    const saved = localStorage.getItem('weplay_profile');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.warn('Profile parse error:', e);
      }
    }
    const randAvatar = this.avatars[Math.floor(Math.random() * this.avatars.length)];
    const randNum = Math.floor(100 + Math.random() * 900);
    return {
      name: `Player_${randNum}`,
      avatar: randAvatar,
      coins: 2500,
      level: 5
    };
  }

  saveProfile(profile) {
    this.profile = { ...this.profile, ...profile };
    localStorage.setItem('weplay_profile', JSON.stringify(this.profile));
  }

  getProfile() {
    return this.profile;
  }
}
